import { Component, ViewEncapsulation, ElementRef, AfterViewInit, Input, HostBinding, inject } from '@angular/core';

@Component({
	selector: 'nha-grid-cell-rabbit-ear',
	templateUrl: './grid-cell-rabbit-ear.component.html',
	styleUrls: ['./grid-cell-rabbit-ear.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: true
})
export class NHAGridCellRabbitEarComponent implements AfterViewInit {
	private _elRef = inject(ElementRef);

	@Input()
	@HostBinding('attr.size')
	size: 's' | 'r' = 'r';

	ngAfterViewInit(): void {
		const target: HTMLElement = this._elRef.nativeElement.querySelector('[cdk-overlay-origin]');
		if (target) {
			target.onclick = (event: UIEvent) => {
				event.stopPropagation();
			};
		}
	}
}
